import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'

import AccessManagement from './AccessManagement'

import { i18n } from '@/translate/i18n'

import * as S from './styles'

import type { RelatedUsersList } from '@/types/components/Modal/Templates/ShareCollection'

interface LinkFormProps {
  isLoading: boolean
  onShowManagementView: () => void
  accessList: RelatedUsersList
  shareLink: string
}

export default function LinkForm({
  isLoading,
  onShowManagementView,
  accessList,
  shareLink
}: LinkFormProps) {
  const [linkWasCopied, setLinkWasCopied] = useState(false)

  const { t } = useTranslation()

  const copyLinkToClipboard = async () => {
    try {
      await window.navigator.clipboard.writeText(shareLink)

      setLinkWasCopied(true)
    } catch {
      Swal.fire({
        icon: 'error',
        title: i18n.t('messages.clipboardPermissionsErrorTitle'),
        text: i18n.t('clipboardPermissionsErrorText')
      })
    }
  }

  if (isLoading) {
    return null
  }

  return (
    <S.LinkFormContainer>
      <S.LinkFormFieldContainer>
        <span>{t('labels.directLink')}</span>
        <input value={shareLink} disabled />
      </S.LinkFormFieldContainer>

      <S.LinkFormButton
        id={linkWasCopied ? 'link-copied-btn' : 'link-copy-btn'}
        onClick={copyLinkToClipboard}
        className={linkWasCopied ? 'active' : ''}
      >
        {linkWasCopied ? t('buttons.linkCopied') : t('buttons.copyLink')}
      </S.LinkFormButton>

      {!!accessList.length && (
        <AccessManagement
          usersList={accessList}
          onShowManagementView={onShowManagementView}
        />
      )}
    </S.LinkFormContainer>
  )
}
